<template lang="">
    <div>
        <b-navbar toggleable="lg" type="dark" variant="primary" fixed="top">
            <b-navbar-brand href="#" @click="$router.back()">
                <b-icon icon="arrow-left"></b-icon> {{$route.query.desc}}
            </b-navbar-brand>
            <b-navbar-nav class="ml-auto">

            </b-navbar-nav>
        </b-navbar>
    <b-row class=" h-100">
        <b-col md="5">
            <b-card >
                <div style="height: 600px ; overflow: auto; " >
                    <b-tree-view   :data="treeData" :contextMenu="false" @nodeSelect="nodeSelect"></b-tree-view>
                </div>
                
            </b-card>
        </b-col>

        <b-col>

            <b-card  header="ຂໍ້ມູນໂຮງຮຽນ">
                <div v-show="selectedNode.visable==1"  >
                    
                    <b-row>
                        <b-col clos="4">
                            ລະຫັດໂຮງຮຽນ:
                        </b-col>
                        <b-col>
                            {{selectedNode.id}}
                            
                        </b-col>

                    </b-row>   
                    <b-row>
                        <b-col clos="4">
                            EMIS CODE:
                        </b-col>
                        <b-col>
                            {{selectedNode.emis_code}}
                        </b-col>

                    </b-row>
                    
                    <b-row>
                        <b-col clos="4">
                            ຊື່ໂຮງຮຽນ:
                        </b-col>
                        <b-col>
                            {{selectedNode.name}}
                        </b-col>

                    </b-row>  

                    <b-row>
                        <b-col clos="4">
                            ລະຫັດເມືອງ:
                        </b-col>
                        <b-col>
                             {{selectedNode.district_id}}
                        </b-col>

                    </b-row> 

                    <b-row>
                        <b-col clos="4">
                            ຊື່ເມືອງ:
                        </b-col>
                        <b-col>
                            {{selectedNode.d_name}}
                        </b-col>

                    </b-row> 

                    <b-row>
                        <b-col clos="4">
                            ລະຫັດແຂວງ:
                        </b-col>
                        <b-col>
                            {{selectedNode.prov_id}}
                        </b-col>

                    </b-row> 
                    <b-row>
                        <b-col clos="4">
                            ຊື່ແຂວງ:
                        </b-col>
                        <b-col>
                            {{selectedNode.p_name}}
                        </b-col>

                    </b-row> 
                </div>
                
                
            </b-card>

        </b-col>
    </b-row>
    </div>
</template>
<script>
import axios from "axios";
export default {
  methods: {
    nodeSelect(node, isSelected) {
        console.log('Node ' + node.data.name + ' has been ' + (isSelected ? 'selected' : 'deselected'))
            if (isSelected) {
                this.selectedNode = node.data
            } else if (node.data === this.selectedNode) {
                this.selectedNode = null
            }

        },
  },
  created () {
    let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);

        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/treeschools"
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.treeData = response.data;
                //    console.log(  JSON.parse(response.data))
            })
  },
  data () {
    return {
        count: 0,
            treeData: [],
            item: "",
            selectedNode: '',
            contextMenuItems: [],
            
    }
  },
    
    
}
</script>
<style lang="">
    
</style>